import { Paper, Table, TableHead, TableBody, TableContainer, TableRow, TableCell, Typography, alpha, Chip, Box} from "@mui/material";
import { parsePhoneNumber } from "libphonenumber-js";
import { Colors } from "../../styles/theme";
import { withPagination } from "../hoc/withPagination";
import { TableHeaderCell } from "../ui";

export default function CustomerTable({
    customers,
    onSelect
}) {

    const handleRowClick = (row) => {
        // Allow selection of any customer
        onSelect(row);
    }

    const getFamilyStatusBadge = (customer) => {
        if (!customer.familyGroupId) {
            return <Chip label="Solo" size="small" variant="outlined" />;
        }
        const familySize = customer.familySize || 1;
        return (
            <Chip 
                label={`Family of ${familySize}`} 
                size="small" 
                color="primary" 
                variant="filled"
            />
        );
    }

    return (
        <>
            {
                
                customers.length > 0 ?
                    <TableContainer component={Paper}>

                        <Table>
                            <TableHead>
                                <TableRow>
                                    {/* <TableHeaderCell>
                            ID
                        </TableHeaderCell> */}
                                    <TableHeaderCell align="center">
                                        First Name
                                    </TableHeaderCell>
                                    <TableHeaderCell align="center">
                                        Last Name
                                    </TableHeaderCell>
                                    <TableHeaderCell align="center">
                                        Phone
                                    </TableHeaderCell>
                                    <TableHeaderCell align="center">
                                        Date of Birth
                                    </TableHeaderCell>
                                    <TableHeaderCell align="center">
                                        Email
                                    </TableHeaderCell>
                                    <TableHeaderCell align="center">
                                        Family Status
                                    </TableHeaderCell>
                                    {/* <TableHeaderCell>
                            Mobile Phone
                        </TableHeaderCell>
                        <TableHeaderCell>
                            Work Phone
                        </TableHeaderCell> */}
                                    {/* <TableHeaderCell align="center">
                                        Actions
                                    </TableHeaderCell> */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    customers.map(p =>
                                        <TableRow sx={{
                                            background: Colors.white,
                                            cursor: 'pointer',
                                            '&:hover': {
                                                background: alpha(Colors.muted, 0.2)
                                            }
                                        }} key={p.id} onClick={() => handleRowClick(p)} >
                                            {/* <TableCell>{p.id}</TableCell> */}
                                            <TableCell align="center" sx={{textTransform: 'capitalize'}}>{p.firstName}</TableCell>
                                            <TableCell align="center" sx={{textTransform: 'capitalize'}}>{p.lastName}</TableCell>
                                            <TableCell align="center">{parsePhoneNumber(`+1${p.mobile}`).formatNational()}</TableCell>
                                            <TableCell align="center">{p.birthdate}</TableCell>
                                            <TableCell align="center">{p.email}</TableCell>
                                            <TableCell align="center">
                                                <Box display="flex" justifyContent="center">
                                                    {getFamilyStatusBadge(p)}
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }

                            </TableBody>
                        </Table>

                    </TableContainer>
                    :
                    <Typography variant="h5" sx={{ color: Colors.light }} textAlign={"center"}>Search by name or phone</Typography>
            }
        </>
    )
}


export const CustomerTableWithPagination = withPagination(CustomerTable);

